import React from "react";

// 页面组件
import HomeView from "../../pages/home";
import ResearchView from "../../pages/research";
import TeachingView from "../../pages/teaching";
import PublicationsView from "../../pages/publication";
import TeamView from "../../pages/team";
import NewsView from "../../pages/news";
import OpeningView from "../../pages/opening";

/**
 * ============================================================================
 * ############## AppRoutes：页面渲染分发 #######################################
 * ============================================================================
 *
 * 【作用】（第三人称客观注释）
 * - 根据 activePage 渲染对应页面组件。
 * - 该组件不负责导航 UI，仅负责“页面选择 → 渲染结果”的映射。
 *
 * 【维护说明】（第三人称客观注释）
 * - 新增页面时，在此处追加一个分支即可。
 * - 若未来引入真正路由（react-router），此组件可作为过渡层替换为 <Routes>。
 */
export interface AppRoutesProps {
  activePage: string;
  lang: "en" | "cn";
  themeMode: "light" | "dark";
  onChangePage: (page: string) => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ activePage, lang, themeMode, onChangePage }) => {
  if (activePage === "home") return <HomeView onChangePage={onChangePage} lang={lang} themeMode={themeMode} />;
  if (activePage === "research") return <ResearchView lang={lang} themeMode={themeMode} />;
  if (activePage === "teaching") return <TeachingView lang={lang} themeMode={themeMode} />;
  if (activePage === "publications") return <PublicationsView lang={lang} themeMode={themeMode} />;
  if (activePage === "team") return <TeamView lang={lang} themeMode={themeMode} />;
  if (activePage === "news") return <NewsView lang={lang} themeMode={themeMode} />;
  if (activePage === "openings") return <OpeningView lang={lang} themeMode={themeMode} />;

  // 默认回退：未知页面 key 时回到首页
  return <HomeView onChangePage={onChangePage} lang={lang} themeMode={themeMode} />;
};

export default AppRoutes;
